import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.GroupOfValuesPopup.TransferAccount', {
    leftPanelTitle: 'Available values',
    rightPanelTitle: 'Selected values',
    leftPanelDescription: '{count} Account(s)',
    rightPanelDescription: '{count} Account(s)',
});
